var CSAService = /** @class */ (function () {
    function CSAService($http, $q) {
        'ngInject';
        this.$http = $http;
        this.$q = $q;
    }
    CSAService.prototype.getOrderHoldCodes = function () {
        var _this = this;
        return this.$http.get('api/cart/orderHoldCodes', { cache: true })
            .then(function (response) {
            return response.data;
        })
            .catch(function (reason) {
            return _this.$q.reject(reason);
        });
    };
    CSAService.prototype.getInventoryDetail = function (warehouseKey, itemId) {
        var _this = this;
        return this.$http.get('api/products/inventoryDetail', { params: { whseKey: warehouseKey, itemId: itemId } })
            .then(function (response) {
            if (response && response.data.errors && response.data.errors.length) {
                return _this.$q.reject(response);
            }
            else {
                return response.data;
            }
        })
            .catch(function (reason) {
            return _this.$q.reject(reason);
        });
    };
    return CSAService;
}());
export { CSAService };
//# sourceMappingURL=csa.service.js.map